export default function Loader() {
    return (
      <div style={{ padding: 24, textAlign: "center" }}>
        <div>Loading...</div>
      </div>
    );
  }
  //added new changes